export default [
  {
    "country": "Austria",
    "code": "AT"
  },
  {
    "country": "Belgium",
    "code": "BE"
  },
  {
    "country": "Bulgaria",
    "code": "BG"
  },
  {
    "country": "Croatia",
    "code": "HR"
  },
  {
    "country": "Cyprus",
    "code": "CY"
  },
  {
    "country": "Czech Republic",
    "code": "CZ"
  },
  {
    "country": "Denmark",
    "code": "DK"
  },
  {
    "country": "Estonia",
    "code": "EE"
  },
  {
    "country": "Finland",
    "code": "FI"
  },
  {
    "country": "France",
    "code": "FR"
  },
  {
    "country": "Germany",
    "code": "DE"
  },
  {
    "country": "Greece",
    "code": "EL"
  },
  {
    "country": "Hungary",
    "code": "HU"
  },
  {
    "country": "Iceland",
    "code": "IS"
  },
  {
    "country": "Ireland",
    "code": "IE"
  },
  {
    "country": "Italy",
    "code": "IT"
  },
  {
    "country": "Latvia",
    "code": "LV"
  },
  {
    "country": "Liechtenstein",
    "code": "LI"
  },
  {
    "country": "Lithuania",
    "code": "LT"
  },
  {
    "country": "Luxembourg",
    "code": "LU"
  },
  {
    "country": "Malta",
    "code": "MT"
  },
  {
    "country": "Netherlands",
    "code": "NL"
  },
  {
    "country": "Norway",
    "code": "NO"
  },
  {
    "country": "Poland",
    "code": "PL"
  },
  {
    "country": "Portugal",
    "code": "PT"
  },
  {
    "country": "Romania",
    "code": "RO"
  },
  {
    "country": "Slovakia",
    "code": "SK"
  },
  {
    "country": "Slovenia",
    "code": "SI"
  },
  {
    "country": "Spain",
    "code": "ES"
  },
  {
    "country": "Sweden",
    "code": "SE"
  },
  {
    "country": "Switzerland",
    "code": "CH"
  },
  {
    "country": "United Kingdom",
    "code": "UK"
  }
]



/** WEBPACK FOOTER **
 ** ./src/lib/countries.js
 **/